window.addEventListener("DOMContentLoaded", function () {
  function outputDataToUl(arr) {
    return `
        <ul>
          ${arr.map((item) => `<li>${item}</li>`).join("")}
        </ul>
      `;
  }

  function init() {
    const productForm = document.querySelector(".product-form form");
    const variantIdInput = document.querySelector("input.product-variant-id");
    const initialVariantId = variantIdInput ? variantIdInput.value : null;
    const specsData = document.querySelector("script[data-product-specs]");
    if (!specsData) throw new Error("no specs data found");
    const parsedSpecsData = JSON.parse(specsData.textContent);

    const productDropdowns = Array.from(
      document.querySelectorAll(".product__accordion")
    );

    // Retrieve the associated
    function getSelectedVariantSpecsById(id) {
      const variantSpecs = parsedSpecsData.find((obj) => obj.id === id);
      if (!variantSpecs) return [null, null];
      const { dimensions, specs } = variantSpecs;
      return [dimensions, specs];
    }

    function updateDropdowns(dimensions, specs) {
      if (productDropdowns.length === 3) {
        const dimensionsDropdown = productDropdowns[0];
        const dimensionsContent = dimensionsDropdown.querySelector(
          ".accordion__content"
        );
        const specsDropdown = productDropdowns[2];
        const specsContent = specsDropdown.querySelector(".accordion__content");

        if (dimensions) {
          dimensionsContent.innerHTML = outputDataToUl(dimensions);
        } else {
          dimensionsContent.innerHTML = "";
        }
        if (specs) {
          specsContent.innerHTML = outputDataToUl(specs);
        } else {
          specsContent.innerHTML = "";
        }
      }
    }
    if (productForm) {
      productForm.addEventListener("change", function (event) {
        const [dimensions, specs] = getSelectedVariantSpecsById(
          event.target.value
        );
        updateDropdowns(dimensions, specs);
      });
    }

    if (initialVariantId) {
      const [dimensions, specs] = getSelectedVariantSpecsById(initialVariantId);
      updateDropdowns(dimensions, specs);
    }
  }

  /**
   *  Observer code for when script is injected into the page.
   */

  // Function to check if the element exists
  function checkForScript() {
    return document.querySelector("script[data-product-specs]");
  }

  // Callback function for MutationObserver
  function mutationCallback(mutationsList, observer) {
    for (const mutation of mutationsList) {
      for (const node of mutation.addedNodes) {
        if (
          node.nodeType === Node.ELEMENT_NODE &&
          node.matches("script[data-product-specs]")
        ) {
          init();
          observer.disconnect(); // Stop observing once the element is found
          return;
        }
      }
    }
  }

  // Create a MutationObserver instance
  const observer = new MutationObserver(mutationCallback);

  // Start observing the document body for changes
  observer.observe(document.body, { childList: true, subtree: true });

  // Initial check in case the element is already present
  if (checkForScript()) {
    init();
    observer.disconnect();
  }
});
